var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('div',{staticClass:"chinese"},[_vm._v("关于我们")]),_c('div',{staticClass:"hx"}),_c('div',{staticClass:"eng"},[_vm._v("About us")])])
}]

export { render, staticRenderFns }